import { CSSProperties, PropsWithChildren } from 'react';

import clsx from 'clsx';

import { PositionOptions } from './TextMediaCanvas/TextMediaCanvas';

import styles from '../m50ShopTheLook.module.css';

export type TextMediaContainerProps = PropsWithChildren<{
	position?: PositionOptions;
	textColor: string;
	offsetContentHeight?: number;
	imageFirstOnMobile?: boolean;
	className?: string;
}>;

export const TextMediaContainer = ({ children, position = 'top', textColor, offsetContentHeight: _offsetContentHeight, imageFirstOnMobile, className }: TextMediaContainerProps) => (
	<div
		className={clsx(
			styles.textMediaContainer,
			{
				[styles.top]: position === 'top',
				[styles.center]: position === 'center',
				[styles.imageFirstOnMobile]: imageFirstOnMobile,
			},
			className,
		)}
		style={{ '--text-color': textColor } as CSSProperties}
	>
		{children}
	</div>
);
